/**
 * Archive sidebar items that belong to a hidden POS rubrique.
 * Hiding orders or reservations also hides their archive entries.
 */
const ORDER_ARCHIVE_KEYS = ["arch-dashboard"];
const RESERVATION_ARCHIVE_KEYS = [
  "arch-table-reservations",
  "arch-plan-floor-setups",
];

export function withLinkedArchiveKeys(disabledKeys = []) {
  const disabled = new Set(disabledKeys);
  const ordersHidden = disabled.has("pos") || disabled.has("pos-orders");
  const reservationsHidden =
    disabled.has("pos") || disabled.has("pos-reservations");

  if (ordersHidden) {
    ORDER_ARCHIVE_KEYS.forEach((key) => disabled.add(key));
  }
  if (reservationsHidden) {
    RESERVATION_ARCHIVE_KEYS.forEach((key) => disabled.add(key));
  }

  return Array.from(disabled);
}
